import {parseISO} from "date-fns";

export const formatMonthLabel = (dateString: string): string => {
    const date = parseISO(dateString);
    return `${date.toLocaleString("pl-PL", {month: "long"})} ${date.getFullYear()}`;
};

const MONTH_LOCATIVE_NAMES = [
    "styczniu",
    "lutym",
    "marcu",
    "kwietniu",
    "maju",
    "czerwcu",
    "lipcu",
    "sierpniu",
    "wrześniu",
    "październiku",
    "listopadzie",
    "grudniu"
];

// "we wrześniu", not "w wrześniu" - Polish euphonic rule before the "wrz-" cluster.
export const formatMonthLocativeLabel = (dateString: string): string => {
    const date = parseISO(dateString);
    const monthName = MONTH_LOCATIVE_NAMES[date.getMonth()];
    const preposition = monthName === "wrześniu" ? "We" : "W";
    return `${preposition} ${monthName} ${date.getFullYear()}`;
};

// Lowercase, no year - for embedding mid-sentence ("... wynoszą w sierpniu ..."), unlike formatMonthLocativeLabel
// which is capitalized and dated for starting a sentence.
export const formatMonthLocativePhrase = (dateString: string): string => {
    const date = parseISO(dateString);
    const monthName = MONTH_LOCATIVE_NAMES[date.getMonth()];
    const preposition = monthName === "wrześniu" ? "we" : "w";
    return `${preposition} ${monthName}`;
};
import {parseISO} from "date-fns";

export const formatMonthLabel = (dateString: string): string => {
    const date = parseISO(dateString);
    return `${date.toLocaleString("pl-PL", {month: "long"})} ${date.getFullYear()}`;
};

const MONTH_LOCATIVE_NAMES = [
    "styczniu",
    "lutym",
    "marcu",
    "kwietniu",
    "maju",
    "czerwcu",
    "lipcu",
    "sierpniu",
    "wrześniu",
    "październiku",
    "listopadzie",
    "grudniu"
];

// "we wrześniu", not "w wrześniu" - Polish euphonic rule before the "wrz-" cluster.
export const formatMonthLocativeLabel = (dateString: string): string => {
    const date = parseISO(dateString);
    const monthName = MONTH_LOCATIVE_NAMES[date.getMonth()];
    const preposition = monthName === "wrześniu" ? "We" : "W";
    return `${preposition} ${monthName} ${date.getFullYear()}`;
};

// Lowercase, no year - for embedding mid-sentence ("... wynoszą w sierpniu ..."), unlike formatMonthLocativeLabel
// which is capitalized and dated for starting a sentence.
export const formatMonthLocativePhrase = (dateString: string): string => {
    const date = parseISO(dateString);
    const monthName = MONTH_LOCATIVE_NAMES[date.getMonth()];
    const preposition = monthName === "wrześniu" ? "we" : "w";
    return `${preposition} ${monthName}`;
};
